<template>
  <v-layout row>
    <v-flex xs12>
      <v-card>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-card-title class="project">
            <span class="headline white--text">Need Assistance?</span>
          </v-card-title>
          <v-card-text>
            
            <v-container grid-list-md>
              <h3>
                We are here to help! Let us know how we can help you. 
              </h3>
              
              <v-layout wrap>
                <v-flex xs12 sm12><br>
                  <p><b>I need help with:</b></p>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-checkbox
                    v-model="assistantData.services"
                    label="Make Questionnaire"
                    value="Make Questionnaire"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="assistantData.services"
                    label="Translation"
                    value="Translation"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="assistantData.services"
                    label="Create Project"
                    value="Create Project"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="assistantData.services"
                    label="Maintain Responses (Accept, Reject etc.)"
                    value="Maintain Responses (Accept- Reject etc.)"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="assistantData.services"
                    label="Analytics & Reporting"
                    value="Analytics & Reporting"
                  ></v-checkbox>
                  <v-checkbox
                    v-model="assistantData.services"
                    label="Other"
                    value="Other"
                  ></v-checkbox>
                  <v-text-field
                    v-if="checkOther()"
                    v-model="assistantData.other_service"
                    label="Other service"
                    :rules="other_rule"
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-container>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="blue darken-1" flat @click="cancel">Close</v-btn>
            <v-btn
              color="blue darken-1"
              :disabled="assistantData.services.length < 1"
              flat
              @click="submit"
              >Submit</v-btn
            >
          </v-card-actions>
        </v-form>
      </v-card>
    </v-flex>
  </v-layout>
</template>
<script>
import axios from "axios";
import { mapGetters } from "vuex";
import api from "../api/connectingUrls";
export default {
  data: () => ({
    valid: true,
    assistantData: {
      services: [],
      other_service: "",
    },
    other_rule: [
      (v) => !!v || "This field is required",
      (v) => (v && v.length <= 60) || "Input must be less than 60 characters",
    ],
  }),
  computed: {
    ...mapGetters(["token"]),
  },
  // created(){

  // },
  methods: {
    initialize() {},
    setErrorZero() {
      this.$store.dispatch("setErrorZero");
    },
    cancel() {
      // console.log(this.token);
      this.$emit("click", false);
    },
    checkOther() {
      if (this.assistantData.services.includes("Other")) {
        return true;
      } else {
        return false;
      }
    },
    submit() {
      if (this.$refs.form.validate()) {
        // const token = window.localStorage.getItem('datadash_token');
        if (this.token != null) {
          axios
            .post(`${api.rootUrl}/${"need-assistant"}`, this.assistantData, {
              headers: {
                Authorization: `Bearer ${this.token}`,
                "Content-Type": "application/json",
              },
            })
            .then((response) => {
              // console.log(response);
              if (response.data.statusCode == 200) {
                this.$store.commit("setErrorMessage", response);
                this.$emit("click", 1);
                //   this.questionData.questions[counter].images.splice(index, 1);
              }
            });
        }
      }
    },
  },
};
</script>
<style lang="stylus" scoped>
.v-progress-circular {
  margin: 1rem;
}

.imageResize {
  width: auto;
  height: auto;
}

.project {
  background: #ff2e2e;
}
</style>